export default __webpack_public_path__ + "static/media/submit-img.960993d0.png";